import src from "../../../assets/login-artwork-left.svg";
import { Asset } from "../Asset";

export const LoginArtworkLeft = Asset(src);
